/*
 * @Descripttion: 
 * @Author: xutao
 * @Date: 2020-06-22 09:39:21
 * @LastEditors: xutao
 * @LastEditTime: 2020-12-24 11:37:53
 * @FilePath: \yunjiactivity-h5\src\pages\vipRecall\api\home.js
 */
import AJAX from '../js/ajax'
import config from '../js/hostnameConfig'

const ajax = AJAX
// const SHARE_PATH = `//${config.sharePath}/sharerevenueweb/app/sharerevenue`

const baseHostname = `//${config.spePath}`
const userPath = `//${config.userPath}`
const BASE_PATH = 'yunjiuseractivityapp/useractivityapp'
const ysappItemBasePath = `//${config.ysappItemBasePath}`

const linkPath = `//${config.linkPath}`
/**
 * 组队活动-检查用户是否需要登录
 * @param {*} params 
 * http://172.16.0.12/showdoc/index.php?s=/30&page_id=8539
 */
export const checkUserApi = params => ajax.get(`${baseHostname}/yunjiuseractivityapp/useractivityapp/teamTask/checkUser.json`, { params })

/**
 * 组队活动-获取验证码
 * @param {*} params 
 * http://172.16.0.12/showdoc/index.php?s=/30&page_id=5644
 */
export const SmsCodeCommonApi = params => ajax.get(`${userPath}/yunjiuserapp/userapp/generateSmsCodeCommon.json`, { params })

/**
 * 组队活动-注册
 * @param {*} params 
 * http://172.16.0.12/showdoc/index.php?s=/30&page_id=8555
 */
export const RegisterApi = params => ajax.get(`${baseHostname}/yunjiuseractivityapp/useractivityapp/teamTask/registerFromTeamTask.json`, { params })

/**
 * 查询shopId对应的头像昵称
 * @param {*} params 
 * http://172.16.0.12/showdoc/index.php?s=/30&page_id=9043
 */
export const fetchUserInfo = params => ajax.get(`${baseHostname}/yunjiuseractivityapp/useractivityapp/getUserInfoByShopId.json`, { params })

/**
 * 关系链气泡接口
 * @param {*} params 
 * http://172.16.0.12/showdoc/index.php?s=/30&page_id=9044
 */
export const getBubbleRelation = params => ajax.get(`${baseHostname}/yunjiuseractivityapp/useractivityapp/getBubbleRelation.json`, { params })

/**
 * 点击领取奖励接口
 * @param {*} params 
 * http://172.16.0.12/showdoc/index.php?s=/30&page_id=9048
 */
export const receiveReward = params => ajax.get(`${baseHostname}/yunjiuseractivityapp/useractivityapp/receiveReward.json`, { params })

/**
 * 获得奖励
 * @param {*} params 
 */
export const remarkReward = params => ajax.get(`${baseHostname}/yunjiuseractivityapp/useractivityapp/remark/reward.json`, { params })

/**
 * 获取上下线 开关
 * @param {*} params 
 * http://172.16.0.36:3000/project/262/interface/api/14732
 */
export const getSwich = params => ajax.get(`${baseHostname}/yunjiuseractivityapp/useractivityapp/queryRelationActivitySwitch.json`, { params })

/**
 * 获取分享开关
 * @param {*} params 
 */
export const queryRelationActivitySecondSharingSwitch = params => ajax.get(`${baseHostname}/yunjiuseractivityapp/useractivityapp/queryRelationActivitySecondSharingSwitch.json`, { params })

/**
 * 福袋页商品信息
 * @param {*} params 
 * http://172.16.0.12/showdoc/index.php?s=/30&page_id=9177
 */
export const getIntelligentItemList = params => ajax.get(`${baseHostname}/${BASE_PATH}/getIntelligentItemList.json`, { params })

/**
 * 智能商品库
 * @param {*} params 
 * http://t-do-dev.yunjiglobal.com/yunjiuseractivityapp/doc.html#/yunjiuseractivityapp/%E7%A6%8F%E8%A2%8B%E6%A8%A1%E5%9D%97/getIntelligentItemsUsingGET_7
 */
export const intelligentItem = params => ajax.get(`${baseHostname}/${BASE_PATH}/intelligent/item.json`, { params })

/**
 * 获取分享信息
 * @param {*} params 
 * http://172.16.0.12/showdoc/index.php?s=/30&page_id=9177
 */
export const getShareContent = params => ajax.get(`${baseHostname}/${BASE_PATH}/getShareContent.json`, { params })

/**
 * 优惠券列表
 * @param {*} params
 */
export const queryMemberCouponList = params => ajax.get(`${userPath}/yunjiuserapp/userapp/member/queryMemberCouponList.json`, { params })
// export const queryMemberCouponList = params => ajax.get(`${userPath}/yunjiuseractivityapp/userapp/member/queryMemberCouponList.json`, { params })

/**
 * 获取小程序码--关系链召回
 * @param {*} params
 * http://172.16.0.12/showdoc/index.php?s=/30&page_id=9181
 */
export const getMiniProgramQrCode = params => ajax.get(`${baseHostname}/${BASE_PATH}/getMiniProgramQrCode.json`, { params })

/**
 * 多买多奖
 * @param {*} params
 * http://172.16.0.12/showdoc/index.php?s=/30&page_id=9182
 */
export const getMoreBuyBanal = params => ajax.get(`${baseHostname}/${BASE_PATH}/getMoreBuyBanal.json`, { params })

/**
 * 获取福袋配置信息
 * @param {*} params
 * http://t-do-dev.yunjiglobal.com/yunjiuseractivityapp/doc.html#/yunjiuseractivityapp/%E7%A6%8F%E8%A2%8B%E6%A8%A1%E5%9D%97/luckBagUsingGET
 */
export const getBagBasicInfor = params => ajax.get(`${baseHostname}/${BASE_PATH}/bag.json`, { params })


/**
 * 获取只能商品库 标签
 * @param {*} params
 */
export const queryItemListMarks = params => ajax.get(`${ysappItemBasePath}/yunjiysapp/app/queryItemListMarks.json`, { params })


/**
 * 获取用户信息
 * @param {*} params
 */
export const memberType = params => ajax.get(`${baseHostname}/${BASE_PATH}/luckBag/memberType.json`, { params })
